<template>
  <div class="cell d-flex flex-column">
    <v-form @submit.prevent="submit" class="d-flex flex-column align-center">
      <h1 class="headline">HealthPass Login</h1>
      <v-text-field
        prepend-inner-icon="mdi-account-outline"
        class="textFieldWidth"
        color="primary"
        label="Username"
        v-model="username"
        :error-messages="usernameErrors"
      ></v-text-field>
      <v-text-field
        prepend-inner-icon="mdi-lock-outline"
        class="textFieldWidth"
        color="primary"
        label="Password"
        type="password"
        v-model="password"
        :error-messages="passwordErrors"
      ></v-text-field>
      <v-btn
        width="180"
        height="40"
        class="buttonText mt-5"
        depressed
        rounded
        :loading="$store.state.base.loading"
        color="primary"
        dark
        
        type="submit"
      >Login</v-btn>

      <!-- <v-btn class="buttonText mt-5" depressed rounded color="primary" dark @click="$router.push('/selfService/dashboard')">Self Test</v-btn> -->
      <!-- <p class="forgot mb-0 mt-4" @click="$router.push('/auth/forgot')">Forgot your Password?</p> -->
    </v-form>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

const fail = function(){
  return !this.failed
}

export default {
  data() {
    return {
      username: "",
      password: "",
      failed: false
    };
  },

  methods: {
    submit() {
      this.$v.$touch();
       if (!this.$v.$invalid) {
         const credentials = {
           username: this.username,
           password: this.password
         }
           this.$store.dispatch('login', credentials)
           .then()
           .catch(err => {
             this.failed = true
             console.log(err.response)
           })
       }

    }
  },

  validations: {
    username: { required, fail },
    password: { required, fail }
  },

  computed: {
   usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      if (!this.$v.username.required) errors.push("Please, Enter your username");
      if (!this.$v.username.fail) errors.push("");
     // if (!this.$v.email.email) errors.push("You must enter a valid email");
      //if (!this.$v.email.loginValidator) errors.push("");
     // if (!this.$v.username.loginNotAcceptedYes) errors.push("");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required)
        errors.push("Please, Enter your password");
        if (!this.$v.password.fail)
        errors.push("");
     // if (!this.$v.password.loginValidator)
      //  errors.push("Email and password do not match. Please try again");

     // if (!this.$v.password.loginNotAcceptedYes)
     //   errors.push(
     //     "Υοu are currently NOT allowed to login. Please contact Dn2Me support"
      //  );
      return errors;
    }
  },
  

  watch: {
    username(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.failed = false
      }
    },
    password(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.failed = false
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.cell {
  padding: 50px 200px;
}

.textFieldWidth {
  width: 300px;
}

.forgot {
  cursor: pointer;
}
</style>
